<div class="container-fluid da-tag-management">
    <div class="row mt-3 da-tag-management__row">
        <!-- Left Panel: Tag Definitions List -->
        <div class="col-md-4 da-tag-management__left">
            <!-- Filters -->
            <div class="card mb-3">
                <div class="card-body row">
                    <div class="form-group col-12 mb-2">
                        <select 
                            class="form-control form-control-sm" 
                            [(ngModel)]="selectedDisciplineId"
                            (change)="onDisciplineChange(selectedDisciplineId)">
                            <option [ngValue]="null">-- Select Discipline --</option>
                            <option *ngFor="let discipline of disciplines" [ngValue]="discipline.id">
                                {{ discipline.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-12 mb-0">
                        <select 
                            class="form-control form-control-sm" 
                            [(ngModel)]="selectedSectionId"
                            (change)="onSectionChange(selectedSectionId)"
                            [disabled]="!selectedDisciplineId">
                            <option [ngValue]="null">-- Select Section --</option>
                            <option *ngFor="let section of filteredSections" [ngValue]="section.id">
                                {{ section.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Tag Definitions List -->
            <div class="card da-tag-management__tag-def-card m-0">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center" style="gap: 8px; min-width: 0;">
                        <h5 class="mb-0">Tag Definitions</h5>
                        <input
                            *ngIf="selectedSectionId"
                            type="text"
                            class="form-control form-control-sm"
                            [(ngModel)]="tagDefinitionSearchText"
                            placeholder="Filter..."
                            style="width: 180px;"
                        />
                    </div>

                    <button class="btn btn-sm btn-primary" (click)="newTagDefinition()" [disabled]="!selectedSectionId">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>

                <div class="card-body p-0 da-tag-management__scroll-body">
                    <div *ngIf="loading" class="text-center p-3">
                        <i class="fa fa-spinner fa-spin"></i> Loading...
                    </div>
                    <ul class="list-group list-group-flush" *ngIf="!loading">
                        <li
                            *ngFor="let def of filteredTagDefinitions"
                            class="list-group-item list-group-item-action"
                            [class.active]="selectedTagDefinition?.id === def.id"
                            (click)="selectTagDefinition(def)"
                            style="cursor: pointer;"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{{ def.engineerFriendlyName }}</strong>
                                    <br/>
                                    <small class="text-muted">
                                        {{ def.baseDeviceTypeName || 'No Base Type' }} | 
                                        {{ def.dataType || 'No Type' }} | 
                                        {{ def.tagCount || 0 }} tags
                                    </small>
                                </div>
                                <button
                                        class="btn btn-sm btn-danger"
                                        (click)="deleteTagDefinition(def); $event.stopPropagation()"
                                        title="Delete"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </li>

                        <li *ngIf="filteredTagDefinitions.length === 0 && tagDefinitions.length > 0" class="list-group-item text-center text-muted">
                            No results for current filter
                        </li>

                        <li *ngIf="tagDefinitions.length === 0 && !selectedSectionId" class="list-group-item text-center text-muted">
                            Please select Discipline and Section above
                        </li>
                        <li *ngIf="tagDefinitions.length === 0 && selectedSectionId" class="list-group-item text-center text-muted">
                            No tag definitions found for selected section
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Middle Panel: Tag Definition Details & Tags -->
        <div class="col-md-8 da-tag-management__right">
            <div *ngIf="!selectedTagDefinition" class="card da-tag-management__details-card">
                <div class="card-body text-center text-muted da-tag-management__details-body">
                    <p>Select a tag definition to view details</p>
                </div>
            </div>

            <!-- Tag Definition Details Component -->
            <app-tag-definition-details
                class="da-tag-management__details-card"
                [selectedTagDefinition]="selectedTagDefinition"
                [filteredBaseDeviceTypes]="filteredBaseDeviceTypes"
                (edit)="editTagDefinition()">
            </app-tag-definition-details>

            <!-- Tag Definition Edit Modal Component -->
            <app-tag-definition-edit-modal
                [isVisible]="isEditingDefinition"
                [selectedTagDefinition]="selectedTagDefinition"
                [filteredBaseDeviceTypes]="filteredBaseDeviceTypes"
                (save)="saveTagDefinition()"
                (cancel)="cancelEditDefinition()">
            </app-tag-definition-edit-modal>

            <!-- Tags List -->
            <div *ngIf="selectedTagDefinition && selectedTagDefinition.id > 0" class="card da-tag-management__tags-card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Tags</h5>
                    <button class="btn btn-sm btn-success" (click)="newTag()">
                        <i class="fa fa-plus"></i> New Tag
                    </button>
                </div>
                <div class="card-body p-0 da-tag-management__scroll-body">
                    <table class="table table-hover mb-0" *ngIf="selectedTagDefinition.tags?.length > 0">
                        <thead>
                        <tr>
                            <th>System Type</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Data Type</th>
                            <th>Default Value</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let tag of selectedTagDefinition.tags">
                            <td>{{ tag.systemTypeName || '-' }}</td>
                            <td>{{ tag.name }}</td>
                            <td>{{ tag.description || '-' }}</td>
                            <td>{{ tag.dataType || '-' }}</td>
                            <td>{{ tag.defaultValue || '-' }}</td>
                            <td>
                                <button class="btn btn-sm btn-warning mr-1" (click)="editTag(tag)" title="Edit">
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button class="btn btn-sm btn-danger" (click)="deleteTag(tag)" title="Delete">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div *ngIf="!selectedTagDefinition.tags || selectedTagDefinition.tags.length === 0"
                         class="text-center p-3 text-muted">
                        No tags found for this definition
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Tag Edit Modal Component -->
<app-tag-edit-modal
    [isVisible]="isEditingTag"
    [selectedTag]="selectedTag"
    [filteredDeviceTypes]="filteredDeviceTypes"
    [filteredSystemTypes]="filteredSystemTypes"
    (save)="saveTag()"
    (cancel)="cancelEditTag()">
</app-tag-edit-modal>
